import callApi, { CallApiResult, getCustomerId } from 'src/api';
import Landingpage from 'src/entities/laindingpage/Landingpage';
import { SCHEMA_LANDINGPAGE_SHAPE } from 'src/schemas/Landingpage';

export const fetchLandingpage = (uuid: string): Promise<CallApiResult> => {
    return callApi(`/api/landingpage/${uuid}`);
};

export const fetchLandingpages = (delegated?: boolean, identifier?: string): Promise<CallApiResult> => {
    const customerId = identifier ?? getCustomerId();
    return callApi(`/api/landingpage/${customerId}/page/list${delegated ? '/delegated' : ''}`);
};

export interface RebateLevel {
    level: number;
    internalName: string | null;
    customerName: string | null;
}

/** R49 (Q834 = B): the Rabattstufen — the only levels a special-price landing page offers. */
export const fetchLandingpageRebateLevels = (): Promise<CallApiResult<RebateLevel[]>> =>
    callApi(`/api/landingpage/${getCustomerId()}/rebateLevels`);

export const submitLandingpage = (
    form: SCHEMA_LANDINGPAGE_SHAPE,
    id?: string,
    identifier?: string
): Promise<CallApiResult> => {
    const infoPages = Object.entries(form.pageData.infoPages ?? {})
        .filter(([_, value]) => value === true)
        .map(([key]) => key);
    const customerId = getCustomerId();

    if (form.pageData.businessCardData?.placement === 'sub') infoPages.push('businessCard');

    const customerIdOrIdentifier = identifier ?? customerId;
    return callApi(`/api/landingpage/${customerIdOrIdentifier}`, {
        method: id ? 'PUT' : 'POST',
        data: {
            id,
            ...form,
            note: form.note ?? '',
            tagIds: form.tagIds ?? [],
            pageData: {
                ...(form.pageData.origin === 'company'
                    ? {
                          companyOwner: form.pageData.companyOwner,
                          companyLogo: form.pageData.companyLogo,
                          companyName: form.pageData.companyName,
                      }
                    : {
                          companyOwner: form.pageData.lamanteOwner,
                          companyLogo: form.pageData.lamanteLogo,
                          companyName: form.pageData.lamanteName,
                      }),
                quote: form.pageData.quote,
                image: form.pageData.image,
                infoPages,
                businessCardData: form.pageData.businessCard ? form.pageData.businessCardData : undefined,
                sections: form.pageData.sections,
                sectionOrder: form.pageData.sectionOrder,
                popupInfo: form.pageData.popupInfo,
                pageConfig: form.pageData.pageConfig,
                variant: form.pageData.variant,
            },
        },
    });
};

export const updateLandingPageCustomRebateData = (
    landingpage: Landingpage,
    identifier?: string
): Promise<CallApiResult> => {
    const customerId = identifier ?? getCustomerId();
    return callApi(`/api/landingpage/${customerId}`, { method: 'PUT', data: landingpage });
};

export const deleteLandingpage = (landingPageId: string, identifier?: string): Promise<CallApiResult> => {
    const customerId = identifier ?? getCustomerId();
    return callApi(`/api/landingpage/${customerId}/${landingPageId}`, {
        method: 'DELETE',
    });
};
